// import React, { useState } from "react";
// import {
//   FaTruck,
//   FaShieldAlt,
//   FaBolt,
//   FaMobileAlt,
//   FaChevronDown,
// } from "react-icons/fa";
 

// const Topbar = () => {
//   const [languageOpen, setLanguageOpen] = useState(false);
//   const [currencyOpen, setCurrencyOpen] = useState(false);

//   return (
//     <div className="mahal-topbar">
//       <div className="container">
//         <div className="topbar-flex">

//           {/* LEFT SIDE */}
//           <div className="left">
//             <div className="left-item">
//               <FaTruck className="icon" />
//               Free Delivery Across Qatar
//             </div>

//             <div className="left-item">
//               <FaShieldAlt className="icon" />
//               100% Verified Suppliers
//             </div>

//             <div className="left-item">
//               <FaBolt className="icon" />
//               Fast Order Processing
//             </div>
//           </div>

//           {/* RIGHT SIDE */}
//           <div className="right">

//             {/* DOWNLOAD APP */}
//            <a href="#" className="download-link highlight-app">
//   <FaMobileAlt className="icon app-icon" />
//   Download Mahal Mobile App
// </a>


//            {/* LANGUAGE */}
// <div className="dropdown">
//   <div
//     className="dropdown-btn"
//     onClick={() => {
//       setLanguageOpen(!languageOpen);
//       setCurrencyOpen(false);
//     }}
//   >
//     English <FaChevronDown size={10} />
//   </div>

//   <div className={`dropdown-content ${languageOpen ? "show" : ""}`}>
//     <div onClick={() => setLanguageOpen(false)}>English</div>
//     <div onClick={() => setLanguageOpen(false)}>العربية</div>
//   </div>
// </div>


//             {/* CURRENCY */}
//             <div className="dropdown">
//               <div
//                 className="dropdown-btn"
//                 onClick={() => {
//                   setCurrencyOpen(!currencyOpen);
//                   setLanguageOpen(false);
//                 }}
//               >
//                 QAR  <FaChevronDown size={10} />
//               </div>

//               {currencyOpen && (
//                <div className={`dropdown-content ${currencyOpen ? "show" : ""}`}>
//                   <div onClick={() => setCurrencyOpen(false)}>QAR </div>
//                   <div onClick={() => setCurrencyOpen(false)}>USD</div>
//                   <div onClick={() => setCurrencyOpen(false)}>EUR</div>
//                 </div>
//               )}
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Topbar;


import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FaTruck,
  FaShieldAlt,
  FaBolt,
  FaMobileAlt,
  FaChevronDown,
} from "react-icons/fa";


const Topbar = () => {
  const [languageOpen, setLanguageOpen] = useState(false);
  const [currencyOpen, setCurrencyOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <div className="mahal-topbar" dir={isArabic ? "rtl" : "ltr"}>
      <div className="container">
        <div className="topbar-flex">

          {/* LEFT SIDE */}
          <div className="left">
            <div className="left-item">
              <FaTruck className="icon" />
              {t("free_delivery_qatar")}
            </div>

            <div className="left-item">
              <FaShieldAlt className="icon" />
              {t("verified_suppliers")}
            </div>

            <div className="left-item">
              <FaBolt className="icon" />
              {t("verified_suppliers")}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="right">

            {/* DOWNLOAD APP */}
            <a href="#" className="download-link highlight-app">
              <FaMobileAlt className="icon app-icon" />
              {t("download_mahal_app")}
            </a>


            {/* LANGUAGE */}
            {/* <div>
          <select
            className="lang_dropdown"
            value={i18n.language}
            onChange={(e) => {
              const lang = e.target.value;
              i18n.changeLanguage(lang);
              document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
              localStorage.setItem("i18nextLng", lang);
            }}
          >
            <option value="en">English</option>
            <option value="ar">العربية</option>
          </select>
            </div> */}

            <div>
              <select
                className="lang_dropdown"
                value={i18n.language}
                onChange={(e) => {
                  const lang = e.target.value;
                  i18n.changeLanguage(lang);
                  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
                  localStorage.setItem("i18nextLng", lang);
                }}
              >
                <option value="en">English</option>
                <option value="ar">العربية</option>
              </select>
            </div>


            {/* CURRENCY */}
            <div className="dropdown">
              <div
                className="dropdown-btn"
                onClick={() => {
                  setCurrencyOpen(!currencyOpen);
                  setLanguageOpen(false);
                }}
              >
                QAR  <FaChevronDown size={10} />
              </div>

              {currencyOpen && (
                <div className={`dropdown-content ${currencyOpen ? "show" : ""}`}>
                  <div onClick={() => setCurrencyOpen(false)}>QAR </div>
                  <div onClick={() => setCurrencyOpen(false)}>USD</div>
                  <div onClick={() => setCurrencyOpen(false)}>EUR</div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;